import { createContext } from "react";


export const IrrigationContext = createContext();